import { render, staticRenderFns } from "./OrderReportDetail.vue?vue&type=template&id=ca4ef0f2"
import script from "./OrderReportDetail.vue?vue&type=script&lang=js"
export * from "./OrderReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports